import { Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PageRoutes from "../Config/PageRoutes";
import { Link } from "react-router-dom";
import React from "react";

import classes from "../Style/Layout.scss";

const ImportantConceptsLink = (props) => {
  return (
    <Box
      sx={{ position: "absolute", right: "0" }}
      className="importantConceptsBtn"
    >
      <Link to={PageRoutes.IMPORTANT_CONCEPTS}>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          className="importanBtn"
          justifyContent="center"
        >
          <InfoOutlinedIcon style={{ color: "white" }} />
          <p id="importanParg"> Important Concepts </p>
        </Box>
      </Link>
    </Box>
  );
};

export default ImportantConceptsLink;
